import React from "react";
import { Alert } from "react-native";
import CustomModal from "../../../components/common/general/CustomModal/CustomModal";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";
import DeleteModule from "../../../components/content/DeleteModule/DeleteModule";
import { useDeleteContentModuleMutation, GetGeneratedContentDocument } from "../../../graphql/generated/graphql";

const DeleteModuleModalContainer = ({ visible, onClose, courseId, moduleName, refetch }) => {
  const { isMedium } = useResponsiveScreen();

  const [deleteModule] = useDeleteContentModuleMutation({
    refetchQueries: [
      {
        query: GetGeneratedContentDocument,
      },
    ],
  });

  const handleDeleteModule = async () => {
    try {
      const response = await deleteModule({
        variables: {
          courseId,
          moduleName,
        },
      });

      if (response.data?.deleteContentModule.success) {
        Alert.alert("Success", "Module deleted successfully");
        onClose();
        refetch();
      } else {
        Alert.alert("Error", response.data?.deleteContentModule.message || "Failed to delete module");
      }
    } catch (error) {
      Alert.alert("Error", "An error occurred while deleting the module.");
    }
  };

  return (
    <CustomModal
      visible={visible}
      onRequestClose={onClose}
      showCloseButton={true}
      title="Delete Module"
      style={{ width: isMedium ? "50%" : "90%" }}>
      <DeleteModule deleteButtonClick={handleDeleteModule} backButtonClick={onClose} />
    </CustomModal>
  );
};

export default DeleteModuleModalContainer;
